import { render, staticRenderFns } from "./1013.vue?vue&type=template&id=52e0cc6e&scoped=true&"
import script from "./1013.vue?vue&type=script&lang=js&"
export * from "./1013.vue?vue&type=script&lang=js&"
import style0 from "./1013.vue?vue&type=style&index=0&id=52e0cc6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e0cc6e",
  null
  
)

export default component.exports